function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "white-clip"
}, /*#__PURE__*/React.createElement("circle", {
  id: "white-eye",
  fill: "#cacaca",
  cx: 130,
  cy: 65,
  r: 20
})), /*#__PURE__*/React.createElement("text", {
  id: "text-s",
  className: "error-text",
  y: 106
}, " 403 "));

var _ref3 = /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#text-s",
  x: "-0.5px",
  y: "-1px",
  fill: "black"
});

var _ref4 = /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#text-s",
  fill: "#2b2b2b"
});

var _ref5 = /*#__PURE__*/React.createElement("g", {
  id: "robot"
}, /*#__PURE__*/React.createElement("g", {
  id: "eye-wrap"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#white-eye"
}), /*#__PURE__*/React.createElement("circle", {
  id: "eyef",
  className: "eye",
  clipPath: "url(#white-clip)",
  fill: "#000",
  stroke: "#2aa7cc",
  strokeWidth: 2,
  strokeMiterlimit: 10,
  cx: 115.07556675062972,
  cy: 62.792792792792795,
  r: 11
}), /*#__PURE__*/React.createElement("ellipse", {
  id: "white-eye",
  fill: "#2b2b2b",
  cx: 130,
  cy: 40,
  rx: 18,
  ry: 12
})), /*#__PURE__*/React.createElement("circle", {
  className: "lightblue",
  cx: 105,
  cy: 32,
  r: 2.5,
  id: "tornillo"
}), /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#tornillo",
  x: 50
}), /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#tornillo",
  x: 50,
  y: 60
}), /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#tornillo",
  y: 60
}));

var Svg403 = function Svg403(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "robot-error",
    viewBox: "0 0 260 118.9",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Svg403, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/403.63b7d918.svg";
export { ForwardRef as ReactComponent };